import { Reducer } from 'redux';
import * as types from './types';

interface ArcadeState {
    readonly id: string | undefined;
    readonly name: string;
    readonly mainRoomId?: string;
    readonly autoplayPreferenceEnabled: boolean;
    readonly instantPlayEnabled: boolean;
}

const arcadeState: ArcadeState = {
    name: '',
    id: undefined,
    mainRoomId: undefined,
    autoplayPreferenceEnabled: true,
    instantPlayEnabled: true,
};

export const arcadeReducer: Reducer<ArcadeState> = (state = arcadeState, action) => {
    switch (action.type) {
        case types.ARCADE__SET_ARCADE_VALUE:
            return {
                ...state,
                [ action.name ]: action.value
            };
        case types.ARCADE__SET_ARCADE: {
            const { success, ...arcade } = action.arcade;
            return {
                ...state,
                ...arcade
            };
        }
        case types.ARCADE__CLEAR_ARCADE:
            return arcadeState;
        default:
            return state;
    }
};
